import React from 'react'
import PropTypes from 'prop-types'

import CompactListComponent from '../CompactListComponent/CompactListComponent'

const CompactEditableListComponent = ({
  onEditClick,
  reorder,
  speakers,
  viewOnly,
}) => {
  const onClick = (speaker) => onEditClick('edit', speaker.live_speaker_id)

  return (
    <div className="compact-editable-list-component">
      <CompactListComponent
        speakers={speakers}
        onEditButtonClick={onClick}
        isEditable
        viewOnly={viewOnly}
        reorder={reorder}
      />
    </div>
  )
}

CompactEditableListComponent.propTypes = {
  speakers: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEditClick: PropTypes.func,
  viewOnly: PropTypes.bool,
  reorder: PropTypes.func,
}

export default CompactEditableListComponent
